/*
 * Copyright (c) 2022 Payoneer Germany GmbH. All rights reserved.
 */

/**
 * Convert URL query params to an object.
 *
 * @param {string} qs Query string from the URL (window.location.search)
 * @returns {Object} - JS object
 */
function parseParams(qs) {
    var params = new URLSearchParams(qs);
    var obj = {};

    for (var key of params.keys()) {
        if (params.getAll(key).length > 1) {
            obj[key] = params.getAll(key);
        } else {
            obj[key] = params.get(key);
        }
    }

    return obj;
}

/**
 * Third party redirect handler which should be available in the
 * return and cancel pages mentioned in list request.
 *
 * @param {function(params?: Object): void} noParentTabCallback - Callback function to execute if the parent tab/window is closed
 *
 * @see https://orchestrationdocs.payoneer.com/docs/integrate-redirect-networks
 * @see https://orchestrationdocs.payoneer.com/docs/create-a-summary-page#code-samples
 */
function providerRedirectHandler(noParentTabCallback) {
    if (!window) {
        return;
    }

    /**
     * @param {Object} winRef Reference of parent window
     */
    var winRef = window.opener;

    /**
     * Query params sent by backend
     */
    var params = parseParams(window.location.search);

    /**
     * User might get redirected to this page twice in a single checkout journey.
     * So if the redirection is happening for second time (through operate.service)
     * then we don't need to do anything.
     */
    if (params?.postRedirect) {
        return;
    }

    /**
     * If URL query params are not present then possibly user accessed the
     * page directly because redirected urls from PSPs must contain query params.
     *
     * @see https://orchestrationdocs.payoneer.com/docs/work-with-interaction-codes
     */
    if (params?.interactionReason || params?.interactionCode) {
        params = {
            ...params,
            interaction: {
                code: params.interactionCode,
                reason: params.interactionReason,
            },
            referrer: window.location.origin + window.location.pathname,
        };

        /**
         * Trigger `noParentTabCallback` callback if parent is closed.
         */
        if (!winRef || winRef.closed) {
            /**
             * Callback is optional but it must be a function
             */
            if (noParentTabCallback && typeof noParentTabCallback !== 'function') {
                return console.error('noParentTabCallback must be a function');
            }

            if (noParentTabCallback) noParentTabCallback(params);
        } else {
            winRef.postMessage(params, window.location.origin);
            window.close();
        }
    }
}

module.exports = {
    providerRedirectHandler,
    parseParams,
};
